import { render, staticRenderFns } from "./NameTranslationOutput.vue?vue&type=template&id=2b1b4208&scoped=true&functional=true"
import script from "./NameTranslationOutput.vue?vue&type=script&lang=js"
export * from "./NameTranslationOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2b1b4208",
  null
  
)

export default component.exports